import React from "react";
import PropTypes from "prop-types";
import styled from 'styled-components';
import ListImg1 from '../../../assets/img/checked2.svg';
import ListImg2 from '../../../assets/img/neutral.png';
import ListImg3 from '../../../assets/img/cross.svg';
import { FormattedHTMLMessage } from 'react-intl';

export default class normeninfo extends React.Component {
    render() {
        return(
<Wrapper>
<TwoRow>
        <RowSpace>
            <ImageModal src={ListImg1} alt="" title="">
            </ImageModal>
        </RowSpace>
        <RowSpace>
    
            <FormattedHTMLMessage id="Normen_List_Point_1" />
      
        </RowSpace>
    </TwoRow>

    <TwoRow>
        <RowSpace>
            <ImageModal src={ListImg2} alt="" title="">
            </ImageModal>
        </RowSpace>
        <RowSpace>
          
            <FormattedHTMLMessage id="Normen_List_Point_2" />
           
          
        </RowSpace>
    </TwoRow>

    <TwoRow>
        <RowSpace>
            <ImageModal src={ListImg3} alt="" title="">
            </ImageModal>
        </RowSpace>
        <RowSpace>
            
            <FormattedHTMLMessage id="Normen_List_Point_3" />
          
        </RowSpace>
    </TwoRow>
</Wrapper>
);
    }
}
const Wrapper = styled.div`
font-family:GROTESK Regular;
font-size:15px;
line-height:20px;
font-weight:100;
`;
const OneRow = styled.div`
clear:left;
`;
const TwoRow = styled.div`
clear:left;
display:flex;
`;
const RowSpace = styled.div`
margin:1%;
margin-top:2rem;
color:black;
float:left;
width:auto;
padding:1%;

`;
const ImageModal= styled.img`
max-width: 2rem;
width:2rem;
display: block;
height: auto;
`;
